import { createContext } from "react";

// Display mode context
export const viewModes = ["cards", "details"] as const;
export type InsightsViewMode = (typeof viewModes)[number];

export const sortOptions = [
  { display: "Rank", slug: "rank" },
  { display: "Job Fit %", slug: "jobFit" },
  { display: "Score", slug: "score" },
  { display: "Date", slug: "date" },
  { display: "ResponseTime", slug: "responseTime" },
  { display: "Ratings", slug: "ratings" },
  { display: "Experience", slug: "experience" },
] as const;

export type InsightsSortSlug = (typeof sortOptions)[number]["slug"];

export const displayPropertyIds = [
  "rank",
  "candidateid",
  "jobFit",
  "name",
  "score",
  "source",
  "date",
  "responseTime",
  "ratings",
  "actions",
] as const;

export type InsightsDisplayProperty = (typeof displayPropertyIds)[number];

export const displayProperties: {
  id: InsightsDisplayProperty;
  label: string;
  mobile?: boolean;
}[] = [
  { id: "rank", label: "Rank" },
  { id: "candidateid", label: "Candidate ID", mobile: false },
  { id: "jobFit", label: "Job Fit %", mobile: false },
  { id: "name", label: "Name" },
  { id: "score", label: "Score" },
  { id: "source", label: "Source", mobile: false },
  { id: "date", label: "Date", mobile: false },
  { id: "responseTime", label: "ResponseTime", mobile: false },
  { id: "ratings", label: "Ratings", mobile: false },
  { id: "actions", label: "Actions" },
];

export const defaultDisplayProperties: InsightsDisplayProperty[] = [
  "rank",
  "candidateid",
  "jobFit",
  "name",
  "score",
  "source",
  "date",
  "responseTime",
  "ratings",
  "actions",
];

// Create context for insights display options
export const InsightsDisplayContext = createContext({
  viewMode: "cards" as InsightsViewMode,
  setViewMode: (mode: InsightsViewMode) => {},
  displayProperties: defaultDisplayProperties as InsightsDisplayProperty[],
  setDisplayProperties: (props: InsightsDisplayProperty[]) => {},
  sortBy: "rank" as InsightsSortSlug,
  setSort: (sort: InsightsSortSlug) => {},
  showShortlisted: false,
  setShowShortlisted: (show: boolean) => {},
  isDirty: false,
  persist: () => {},
  reset: () => {},
});

// Candidate context for selections
export const CandidateListContext = createContext({
  shortlistedCandidates: [] as string[],
  setShortlistedCandidates: (candidates: string[]) => {},
  selectedCandidates: new Set<string>(),
  setSelectedCandidates: (candidates: Set<string>) => {},
  openMenuCandidateId: null as string | null,
  setOpenMenuCandidateId: (id: string) => {},
});
